import React, { useState, useEffect } from "react";
import clienteAxios from "../helpers/axios.helper";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const MarcaABM = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const marcaEnEdicion = location.state?.marca || null;
  const modoEdicion = location.state?.modoEdicion || false;

  const [nombre, setNombre] = useState("");
  const [detalle, setDetalle] = useState("");
  const [imagen, setImagen] = useState(null);

  // Cargar datos en caso de edición
  useEffect(() => {
    if (modoEdicion && marcaEnEdicion) {
      setNombre(marcaEnEdicion.nombre || "");
      setDetalle(marcaEnEdicion.detalle || "");
      setImagen(marcaEnEdicion.imagen || null);
    }
  }, [modoEdicion, marcaEnEdicion]);

  // Función para manejar la creación de marcas
  const crearMarca = async () => {
       if (!imagen) {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Por favor, selecciona una imagen para el producto.",
          });
          return;
        }
    try {
      Swal.fire({
        title: "Guardando...",
        text: "Por favor espera mientras se procesa la acción.",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading(); // Mostrar animación de carga
        },
      });
      const formData = new FormData();
      formData.append("nombre", nombre);
      formData.append("detalle", detalle);
      formData.append("imagen", imagen);

      const response = await clienteAxios.post("/marcas", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response.status === 200) {
        Swal.close(); // Cerrar el mensaje de carga
        Swal.fire({
          icon: "success",
          title: "¡Marca creada!",
          text: "La marca se ha creado con éxito.",
        });
        resetFormulario();
        setTimeout(() => {
          navigate('/panel_administracion')
          // Código que se ejecutará después de 1 segundo
        }, 1000);
      }
    } catch (error) {
      Swal.close(); // Cerrar el mensaje de carga
      manejarErrores(error);
    }
  };

  // Función para manejar la edición de marcas
  const editarMarca = async () => {
    try {
      Swal.fire({
        title: "Guardando...",
        text: "Por favor espera mientras se procesa la acción.",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading(); // Mostrar animación de carga
        },
      });
      const formData = new FormData();
      formData.append("nombre", nombre);
      formData.append("detalle", detalle);
      if (!imagen) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Por favor, selecciona una imagen para el producto.",
        });
        return;
      } else { formData.append("imagen", imagen); }

      const response = await clienteAxios.put(
        `/marcas/${marcaEnEdicion.id}`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      if (response.status === 200) {
        Swal.close(); // Cerrar el mensaje de c
        Swal.fire({
          icon: "success",
          title: "¡Marca actualizada!",
          text: "La marca ha sido actualizada con éxito.",
        });
        resetFormulario();
        setTimeout(() => {
          navigate('/panel_administracion')
          // Código que se ejecutará después de 1 segundo
        }, 1000);
      }
    } catch (error) {
      Swal.close(); // Cerrar el mensaje de c
      manejarErrores(error);
    }
  };

  // Función para manejar errores
  const manejarErrores = (error) => {
    if (error.response) {
      const { status, data } = error.response;

      if (status === 400) {
        Swal.fire({
          icon: "error",
          title: "¡Error al subir el archivo!",
          text: data.error || "El archivo tiene un formato o tamaño inválido.",
        });
        return;
      }
    }

    // Mensaje genérico en caso de error inesperado
    Swal.fire({
      icon: "error",
      title: "¡Error!",
      text: "Hubo un problema. Por favor, inténtalo nuevamente.",
    });
  };

  // Manejar el envío del formulario
  const handleSubmit = (e) => {
    e.preventDefault();
    if (modoEdicion) {
      editarMarca();
    } else {
      crearMarca();
    }
  };

  // Resetear el formulario
  const resetFormulario = () => {
    setNombre("");
    setDetalle("");
    setImagen(null);
  };

  return (
    
    <div className="p-6 max-w-4xl mx-auto my-10 border-2 border-GrisOscuro bg-white rounded-md">
      <h1 className="text-2xl font-bold mb-4">
        {modoEdicion ? "Editar Marca" : "Crear Marca"}
      </h1>

      <form onSubmit={handleSubmit} className="space-y-4">
        {/* Nombre de la marca */}
        <div>
          <label className="block text-gray-700 font-medium mb-2">
            Nombre de la Marca
          </label>
          <input
            type="text"
            className="w-full p-2 border rounded-md"
            value={nombre}
            onChange={(e) => setNombre(e.target.value)}
            placeholder="Ingrese el nombre de la marca"
            required
          />
        </div>

        {/* Detalle */}
        <div>
          <label className="block text-gray-700 font-medium mb-2">Detalle</label>
          <textarea
            className="w-full p-2 border rounded-md"
            value={detalle}
            onChange={(e) => setDetalle(e.target.value)}
            placeholder="Ingrese un detalle de la marca"
            rows="3"
            required
          />
        </div>

        {/* Imagen */}
        <div>
          <label className="block text-gray-700 font-medium mb-2">
            Cargar Imagen
          </label>
          <input
            type="file"
            className="w-full p-2 border rounded-md"
            onChange={(e) => setImagen(e.target.files[0])}
            accept="image/*"
          />
        </div>

        {/* Botón de envío */}
        <button
          type="submit"
          className="w-full bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600"
        >
          {modoEdicion ? "Guardar Cambios" : "Crear Marca"}
        </button>
      </form>
    </div>
  );
};

export default MarcaABM;
